/* JADUZAR SHOP — storefront behaviour.
   Everything talks to Shopify's own endpoints: Ajax cart, predictive search,
   the Section Rendering API and the localization form. Wishlist and recently
   viewed are device-local (localStorage) by design; see the setup guide. */
(function () {
  'use strict';
  var JZ = window.JZ || { routes: {}, settings: {}, strings: {}, market: {} };
  var $ = function (sel, root) { return (root || document).querySelector(sel); };
  var $$ = function (sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); };

  function store(key, fallback) {
    try { var v = localStorage.getItem(key); return v ? JSON.parse(v) : fallback; } catch (e) { return fallback; }
  }
  function save(key, value) { try { localStorage.setItem(key, JSON.stringify(value)); } catch (e) {} }

  var toastEl;
  function toast(text) {
    if (!text) return;
    if (!toastEl) { toastEl = document.createElement('div'); toastEl.className = 'toast'; toastEl.setAttribute('role', 'status'); document.body.appendChild(toastEl); }
    toastEl.textContent = text;
    toastEl.classList.add('show');
    clearTimeout(toastEl._t);
    toastEl._t = setTimeout(function () { toastEl.classList.remove('show'); }, 2200);
  }

  /* ---------- Dialogs & drawers (native <dialog>: focus trap + Escape for free) ---------- */
  var lastOpener = null;
  function openDialog(el, opener) {
    if (!el || el.open) return;
    lastOpener = opener || document.activeElement;
    if (typeof el.showModal === 'function') el.showModal(); else el.setAttribute('open', '');
    document.documentElement.style.overflow = 'hidden';
    var focusTarget = el.querySelector('[data-autofocus]') || el.querySelector('input, button, a');
    if (focusTarget) setTimeout(function () { focusTarget.focus(); }, 30);
    el.dispatchEvent(new CustomEvent('jz:open'));
  }
  function closeDialog(el) {
    if (!el || !el.open) return;
    if (typeof el.close === 'function') el.close(); else el.removeAttribute('open');
  }
  document.addEventListener('close', function (e) {
    if (e.target.matches && e.target.matches('dialog.jz-dialog')) {
      if (!document.querySelector('dialog.jz-dialog[open]')) document.documentElement.style.overflow = '';
      if (lastOpener && lastOpener.focus) lastOpener.focus();
    }
  }, true);
  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-open]');
    if (opener) {
      var target = $('[data-dialog="' + opener.getAttribute('data-open') + '"]');
      if (target) { e.preventDefault(); openDialog(target, opener); return; }
    }
    var closer = e.target.closest('[data-close]');
    if (closer) { e.preventDefault(); closeDialog(closer.closest('dialog')); return; }
    /* click on the backdrop */
    if (e.target.matches && e.target.matches('dialog.jz-dialog[open]')) {
      var r = e.target.getBoundingClientRect();
      if (e.clientX < r.left || e.clientX > r.right || e.clientY < r.top || e.clientY > r.bottom) closeDialog(e.target);
    }
  });

  /* ---------- Cart ---------- */
  function updateCartCount(count) {
    $$('[data-cart-count]').forEach(function (el) {
      el.textContent = count > 0 ? count : '';
      if (count > 0) el.removeAttribute('data-zero'); else el.setAttribute('data-zero', '');
    });
  }
  function refreshCartDrawer(open) {
    return fetch(JZ.routes.root + '?sections=cart-drawer', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (json) {
        var html = json['cart-drawer'];
        if (!html) return;
        var tmp = document.createElement('div'); tmp.innerHTML = html;
        var fresh = tmp.querySelector('[data-cart-drawer-content]');
        var current = $('[data-cart-drawer-content]');
        if (fresh && current) current.innerHTML = fresh.innerHTML;
        var count = fresh ? Number(fresh.getAttribute('data-item-count') || 0) : 0;
        updateCartCount(count);
        if (open) openDialog($('[data-dialog="cart"]'));
      });
  }
  function addToCart(payload, button) {
    if (button) { button.disabled = true; button.setAttribute('data-label', button.textContent); button.textContent = JZ.strings.adding || '…'; }
    return fetch(JZ.routes.cartAdd + '.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(payload)
    }).then(function (r) { return r.json().then(function (j) { return { ok: r.ok, json: j }; }); })
      .then(function (res) {
        if (!res.ok) throw new Error(res.json.description || res.json.message || JZ.strings.cartError);
        document.dispatchEvent(new CustomEvent('jz:cart:added', { detail: res.json }));
        return refreshCartDrawer(true);
      })
      .catch(function (err) { toast(err.message || JZ.strings.cartError); })
      .then(function () { if (button) { button.disabled = false; button.textContent = button.getAttribute('data-label'); } });
  }
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.matches('[data-product-form]')) return;
    e.preventDefault();
    var id = form.querySelector('[name="id"]').value;
    var qtyEl = form.querySelector('[name="quantity"]');
    var qty = qtyEl ? Math.max(1, parseInt(qtyEl.value, 10) || 1) : 1;
    var error = form.querySelector('[data-form-error]');
    if (error) error.textContent = '';
    if (!id) { if (error) error.textContent = JZ.strings.selectSize; return; }
    var props = {};
    $$('[name^="properties["]', form).forEach(function (inp) { if (inp.value) props[inp.name.slice(11, -1)] = inp.value; });
    addToCart({ id: Number(id), quantity: qty, properties: props }, form.querySelector('[type="submit"]'));
  });
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-cart-change]');
    if (!btn) return;
    e.preventDefault();
    var line = btn.getAttribute('data-line');
    var quantity = Number(btn.getAttribute('data-quantity'));
    var wrap = btn.closest('[data-cart-drawer-content], [data-cart-page]');
    if (wrap) wrap.style.opacity = '.5';
    fetch(JZ.routes.cartChange + '.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line: Number(line), quantity: quantity })
    }).then(function (r) { return r.json(); })
      .then(function () {
        if ($('[data-cart-page]')) { window.location.reload(); return; }
        return refreshCartDrawer(false);
      })
      .catch(function () { toast(JZ.strings.cartError); })
      .then(function () { if (wrap) wrap.style.opacity = ''; });
  });
  /* quantity steppers (product form + cart page) */
  document.addEventListener('click', function (e) {
    var step = e.target.closest('[data-qty-step]');
    if (!step) return;
    var input = step.parentElement.querySelector('input[type="number"]');
    if (!input) return;
    var next = (parseInt(input.value, 10) || 1) + Number(step.getAttribute('data-qty-step'));
    input.value = Math.max(Number(input.min || 1), next);
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ---------- Product form: variants ---------- */
  function initProductForm(root) {
    var jsonEl = root.querySelector('[data-variant-json]');
    if (!jsonEl) return;
    var variants; try { variants = JSON.parse(jsonEl.textContent); } catch (e) { return; }
    var idInput = root.querySelector('[name="id"]');
    var button = root.querySelector('[data-add-button]');
    var priceEl = root.querySelector('[data-price]');
    var compareEl = root.querySelector('[data-compare-price]');
    var availEl = root.querySelector('[data-availability]');
    var optionCount = Number(root.getAttribute('data-option-count') || 0);
    var moneyFormat = root.getAttribute('data-money-format') || '{{amount}}';
    var mobilePrice = $('[data-mobile-price]');

    function money(cents) {
      var val = (cents / 100).toFixed(2);
      var parts = val.split('.');
      var withThousands = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      var out = moneyFormat
        .replace('{{amount_with_comma_separator}}', parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ',' + parts[1])
        .replace('{{amount_no_decimals_with_comma_separator}}', parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.'))
        .replace('{{amount_no_decimals}}', withThousands)
        .replace('{{amount}}', withThousands + '.' + parts[1]);
      return out;
    }
    function selectedOptions() {
      var out = [];
      for (var i = 1; i <= optionCount; i++) {
        var checked = root.querySelector('[name="option' + i + '"]:checked, select[name="option' + i + '"]');
        out.push(checked ? checked.value : null);
      }
      return out;
    }
    function findVariant(opts) {
      return variants.find(function (v) { return opts.every(function (o, i) { return o === null || v.options[i] === o; }); });
    }
    function markAvailability(opts) {
      /* for every option value, is there an available variant that matches the other selected values? */
      for (var i = 1; i <= optionCount; i++) {
        $$('[name="option' + i + '"]', root).forEach(function (input) {
          var trial = opts.slice(); trial[i - 1] = input.value;
          var any = variants.some(function (v) { return v.available && trial.every(function (o, j) { return o === null || j === i - 1 || v.options[j] === o; }) && v.options[i - 1] === input.value; });
          var label = input.closest('label');
          if (label) label.classList.toggle('unavailable', !any);
          input.setAttribute('aria-disabled', any ? 'false' : 'true');
        });
      }
    }
    function update() {
      var opts = selectedOptions();
      var v = findVariant(opts);
      markAvailability(opts);
      $$('[data-option-output]', root).forEach(function (out) {
        var i = Number(out.getAttribute('data-option-output')); out.textContent = opts[i - 1] || '';
      });
      if (!v) {
        idInput.value = '';
        if (button) { button.disabled = true; button.textContent = JZ.strings.unavailable; }
        if (availEl) { availEl.textContent = JZ.strings.unavailable; availEl.classList.add('out'); }
        return;
      }
      idInput.value = v.id;
      var notify = $('[data-notify]');
      if (notify) {
        notify.hidden = !!v.available;
        var nv = notify.querySelector('[data-notify-variant]'); if (nv) nv.value = v.title || '';
        var ns = notify.querySelector('[data-notify-sku]'); if (ns) ns.value = v.sku || '';
        var nt = notify.querySelector('[data-notify-tags]'); if (nt) nt.value = nt.getAttribute('data-prefix') + v.id;
      }
      if (priceEl) priceEl.textContent = money(v.price);
      if (mobilePrice) mobilePrice.textContent = money(v.price);
      if (compareEl) { if (v.compare_at_price && v.compare_at_price > v.price) { compareEl.textContent = money(v.compare_at_price); compareEl.hidden = false; } else compareEl.hidden = true; }
      if (button) { button.disabled = !v.available; button.textContent = v.available ? JZ.strings.addToBag : JZ.strings.soldOut; }
      $$('[data-mobile-add]').forEach(function (b) { b.disabled = !v.available; b.textContent = v.available ? JZ.strings.addToBag : JZ.strings.soldOut; });
      if (availEl) { availEl.textContent = v.available ? availEl.getAttribute('data-in-stock') : JZ.strings.soldOut; availEl.classList.toggle('out', !v.available); }
      if (v.featured_media && v.featured_media.id) {
        var fig = document.querySelector('[data-media-id="' + v.featured_media.id + '"]');
        if (fig) scrollGalleryTo(fig);
      }
      if (history.replaceState) {
        var url = new URL(window.location.href); url.searchParams.set('variant', v.id); history.replaceState({}, '', url.toString());
      }
    }
    root.addEventListener('change', function (e) { if (/^option\d+$/.test(e.target.name)) update(); });
    update();
  }
  function scrollGalleryTo(fig) {
    var main = fig.closest('.gallery-main');
    if (!main) return;
    if (window.innerWidth <= 560) main.scrollTo({ left: fig.offsetLeft, behavior: 'smooth' });
    else fig.scrollIntoView({ behavior: 'smooth', block: 'center' });
    $$('.gallery-thumbs button').forEach(function (b) { b.setAttribute('aria-current', b.getAttribute('data-media-target') === fig.getAttribute('data-media-id') ? 'true' : 'false'); });
  }
  document.addEventListener('click', function (e) {
    var thumb = e.target.closest('[data-media-target]');
    if (!thumb) return;
    var fig = document.querySelector('[data-media-id="' + thumb.getAttribute('data-media-target') + '"]');
    if (fig) scrollGalleryTo(fig);
  });
  function initMobileAdd() {
    var bar = $('.mobile-add'); var button = $('[data-add-button]');
    if (!bar || !button || !('IntersectionObserver' in window)) { if (bar) bar.classList.add('is-visible'); return; }
    var io = new IntersectionObserver(function (entries) { bar.classList.toggle('is-visible', !entries[0].isIntersecting && entries[0].boundingClientRect.top < 0); }, { threshold: 0 });
    io.observe(button);
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-mobile-add]');
    if (!b) return;
    var form = $('[data-product-form]');
    if (form) form.requestSubmit ? form.requestSubmit() : form.dispatchEvent(new Event('submit', { cancelable: true, bubbles: true }));
  });

  /* ---------- Wishlist (device-local) ---------- */
  var WL_KEY = 'jz_wishlist';
  function wishlist() { return store(WL_KEY, []); }
  function wishlistHas(productId) { return wishlist().some(function (i) { return String(i.id) === String(productId); }); }
  function wishlistSet(items) { save(WL_KEY, items); paintWishlist(); document.dispatchEvent(new CustomEvent('jz:wishlist:change')); }
  function paintWishlist() {
    fitCutouts(); /* runs after every render of product cards (page load, search, recommendations, wishlist) */
    var items = wishlist();
    $$('[data-wishlist-count]').forEach(function (el) { el.textContent = items.length ? items.length : ''; if (items.length) el.removeAttribute('data-zero'); else el.setAttribute('data-zero', ''); });
    $$('[data-wishlist-toggle]').forEach(function (btn) {
      var on = wishlistHas(btn.getAttribute('data-product-id'));
      btn.setAttribute('aria-pressed', on ? 'true' : 'false');
      btn.setAttribute('aria-label', on ? JZ.strings.removeFromWishlist : JZ.strings.saveToWishlist);
      var label = btn.querySelector('[data-wishlist-label]');
      if (label) label.textContent = on ? JZ.strings.savedToWishlist : JZ.strings.saveToWishlist;
    });
  }
  function wishlistAdd(entry) {
    var items = wishlist().filter(function (i) { return String(i.id) !== String(entry.id); });
    items.unshift(entry);
    wishlistSet(items.slice(0, 60));
    toast(JZ.strings.savedToWishlist);
  }
  function wishlistRemove(productId) {
    wishlistSet(wishlist().filter(function (i) { return String(i.id) !== String(productId); }));
  }

  /* size dialog: shared by wishlist (mode=wishlist) and quick add (mode=cart) */
  var sizeDialog = null;
  function askSize(opts) {
    sizeDialog = sizeDialog || $('[data-size-dialog]');
    if (!sizeDialog) return;
    var list = sizeDialog.querySelector('[data-size-options]');
    var saveBtn = sizeDialog.querySelector('[data-size-save]');
    var title = sizeDialog.querySelector('[data-size-title]');
    var price = sizeDialog.querySelector('[data-size-price]');
    var label = sizeDialog.querySelector('[data-size-label]');
    var thumb = sizeDialog.querySelector('[data-size-thumb]');
    var err = sizeDialog.querySelector('[data-size-error]');
    if (title) title.textContent = opts.title || '';
    if (price) price.textContent = opts.price || '';
    if (label) label.textContent = opts.kind === 'colour' ? (JZ.strings.selectColour || JZ.strings.selectSize) : JZ.strings.selectSize;
    if (thumb) { if (opts.image) { thumb.src = opts.image; thumb.hidden = false; } else { thumb.hidden = true; thumb.removeAttribute('src'); } }
    if (err) err.textContent = '';
    list.className = 'dialog-sizes' + (opts.kind === 'colour' ? ' is-colours' : '');
    list.innerHTML = '';
    var chosen = null;
    opts.sizes.forEach(function (s) {
      var b = document.createElement('button'); b.type = 'button'; b.textContent = s.label; b.disabled = !s.available && opts.mode === 'cart';
      if (!s.available) b.setAttribute('aria-label', s.label + ' — ' + JZ.strings.soldOut);
      b.setAttribute('aria-pressed', 'false');
      b.addEventListener('click', function () { chosen = s; $$('button', list).forEach(function (x) { x.setAttribute('aria-pressed', 'false'); }); b.setAttribute('aria-pressed', 'true'); saveBtn.disabled = false; });
      list.appendChild(b);
    });
    saveBtn.disabled = true;
    saveBtn.textContent = opts.mode === 'cart' ? JZ.strings.addToBag : JZ.strings.saveToWishlist;
    saveBtn.onclick = function () {
      if (!chosen) { if (err) err.textContent = opts.kind === 'colour' ? (JZ.strings.selectColour || JZ.strings.selectSize) : JZ.strings.selectSize; return; }
      closeDialog(sizeDialog);
      opts.onChoose(chosen);
    };
    openDialog(sizeDialog);
  }
  function parseSizes(btn) {
    var raw = (btn.getAttribute('data-sizes') || '').trim();
    if (!raw) return [];
    return raw.split('|').map(function (rec) { var p = rec.split('::'); return { id: Number(p[0]), label: p[1] || '', available: p[2] === 'true' }; }).filter(function (s) { return s.id; });
  }
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-wishlist-toggle]');
    if (!btn) return;
    e.preventDefault();
    var pid = btn.getAttribute('data-product-id');
    if (wishlistHas(pid)) { wishlistRemove(pid); toast(JZ.strings.removeFromWishlist); return; }
    var sizes = parseSizes(btn);
    var base = { id: Number(pid), handle: btn.getAttribute('data-product-handle'), title: btn.getAttribute('data-product-title'), added: Date.now() };
    /* on the product page respect an already chosen size */
    var form = btn.closest('[data-product-form-wrap]') ? $('[data-product-form]', btn.closest('[data-product-form-wrap]')) : null;
    if (form) {
      var sizeInput = form.querySelector('[data-size-option]:checked');
      var vid = form.querySelector('[name="id"]').value;
      if (sizeInput || sizes.length < 2) { base.size = sizeInput ? sizeInput.value : null; base.variantId = vid ? Number(vid) : null; wishlistAdd(base); return; }
    }
    if (sizes.length > 1) {
      askSize({ mode: 'wishlist', kind: 'size', title: base.title, sizes: sizes, onChoose: function (s) { base.size = s.label; base.variantId = s.id; wishlistAdd(base); } });
    } else {
      base.size = sizes[0] ? sizes[0].label : null; base.variantId = sizes[0] ? sizes[0].id : null; wishlistAdd(base);
    }
  });
  document.addEventListener('click', function (e) {
    var rm = e.target.closest('[data-wishlist-remove]');
    if (!rm) return;
    e.preventDefault();
    wishlistRemove(rm.getAttribute('data-product-id'));
    var card = rm.closest('.product-card'); if (card) card.remove();
    var page = $('[data-wishlist-page]'); if (page && !wishlist().length) renderWishlistPage();
  });

  /* quick add from cards: sizes, else colours, else the single variant — all from real variants */
  document.addEventListener('click', function (e) {
    var qa = e.target.closest('[data-quick-add]');
    if (!qa) return;
    e.preventDefault();
    var sizes = parseSizes(qa);
    var kind = qa.getAttribute('data-kind') || 'size';
    if (!sizes.length) { window.location.href = qa.getAttribute('data-product-url'); return; }
    if (kind === 'single' || sizes.length === 1) { if (sizes[0].available) addToCart({ id: sizes[0].id, quantity: 1 }, qa); else toast(JZ.strings.soldOut); return; }
    askSize({ mode: 'cart', kind: kind, title: qa.getAttribute('data-product-title'), price: qa.getAttribute('data-product-price'), image: qa.getAttribute('data-product-image'), sizes: sizes, onChoose: function (s) { addToCart({ id: s.id, quantity: 1 }); } });
  });

  /* ---------- Section rendering helpers (server-rendered product cards by id) ---------- */
  function fetchProductsSection(sectionId, ids, extra) {
    if (!ids.length) return Promise.resolve(null);
    var q = ids.map(function (id) { return 'id:' + id; }).join(' OR ');
    var url = JZ.routes.search + '?section_id=' + encodeURIComponent(sectionId) + '&type=product&options[unavailable_products]=last&q=' + encodeURIComponent(q) + (extra || '');
    return fetch(url).then(function (r) { return r.ok ? r.text() : null; }).then(function (html) {
      if (!html) return null;
      var tmp = document.createElement('div'); tmp.innerHTML = html;
      return tmp.querySelector('[data-section-results]');
    });
  }
  function orderCards(container, ids) {
    var cards = $$('[data-product-card]', container);
    var byId = {}; cards.forEach(function (c) { byId[c.getAttribute('data-product-id')] = c; });
    var frag = document.createDocumentFragment();
    ids.forEach(function (id) { if (byId[id]) frag.appendChild(byId[id]); });
    container.innerHTML = ''; container.appendChild(frag);
  }

  /* ---------- Wishlist page ---------- */
  function renderWishlistPage() {
    var page = $('[data-wishlist-page]');
    if (!page) return;
    var items = wishlist();
    var empty = page.querySelector('[data-wishlist-empty]');
    var grid = page.querySelector('[data-wishlist-grid]');
    var actions = page.querySelector('[data-wishlist-actions]');
    if (!items.length) { if (empty) empty.hidden = false; if (grid) grid.innerHTML = ''; if (actions) actions.hidden = true; return; }
    if (empty) empty.hidden = true; if (actions) actions.hidden = false;
    fetchProductsSection('wishlist', items.map(function (i) { return i.id; })).then(function (results) {
      if (!results || !grid) return;
      grid.innerHTML = results.innerHTML;
      orderCards(grid, items.map(function (i) { return String(i.id); }));
      items.forEach(function (i) {
        var card = grid.querySelector('[data-product-card][data-product-id="' + i.id + '"]');
        if (!card) return;
        var meta = card.querySelector('[data-wishlist-meta]');
        if (meta) {
          meta.hidden = false;
          var sizeEl = meta.querySelector('[data-wishlist-size]');
          if (sizeEl) sizeEl.textContent = i.size ? i.size : '';
          var addBtn = meta.querySelector('[data-wishlist-add]');
          if (addBtn) { if (i.variantId) addBtn.setAttribute('data-variant-id', i.variantId); else addBtn.hidden = true; }
        }
      });
      paintWishlist();
    });
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-wishlist-add]');
    if (!b) return;
    e.preventDefault();
    var vid = b.getAttribute('data-variant-id');
    if (vid) addToCart({ id: Number(vid), quantity: 1 }, b);
  });
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-wishlist-clear]');
    if (!b) return;
    e.preventDefault();
    wishlistSet([]); renderWishlistPage();
  });

  /* ---------- Recently viewed ---------- */
  var RV_KEY = 'jz_recent';
  function recordView() {
    var el = $('[data-product-viewed]');
    if (!el || !JZ.settings.recentlyViewed) return;
    var id = el.getAttribute('data-product-viewed');
    var list = store(RV_KEY, []).filter(function (x) { return String(x) !== String(id); });
    list.unshift(Number(id));
    save(RV_KEY, list.slice(0, 20));
  }
  function renderRecentlyViewed() {
    $$('[data-recently-viewed]').forEach(function (section) {
      var exclude = section.getAttribute('data-exclude');
      var limit = Number(section.getAttribute('data-limit') || JZ.settings.recentlyViewedLimit || 8);
      var ids = store(RV_KEY, []).filter(function (x) { return String(x) !== String(exclude); }).slice(0, limit);
      if (!ids.length) { section.hidden = true; return; }
      fetchProductsSection(section.getAttribute('data-section-file') || 'recently-viewed', ids).then(function (results) {
        var grid = section.querySelector('[data-recent-grid]');
        if (!results || !grid || !results.children.length) { section.hidden = true; return; }
        grid.innerHTML = results.innerHTML;
        orderCards(grid, ids.map(String));
        section.hidden = false;
        paintWishlist(); dedupeRecent();
      });
    });
  }

  /* ---------- Search (predictive) ---------- */
  function initSearch() {
    var dialog = $('[data-dialog="search"]');
    if (!dialog) return;
    var input = dialog.querySelector('[data-search-input]');
    var results = dialog.querySelector('[data-search-results]');
    var discovery = dialog.querySelector('[data-search-discovery]');
    var recentBlock = dialog.querySelector('[data-search-recent]');
    var timer, lastQuery = '', controller;
    function escapeHtml(s) { return String(s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
    function search(q) {
      if (controller) controller.abort();
      controller = new AbortController();
      var url = JZ.routes.predictiveSearch + '?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=10&resources[options][unavailable_products]=last&resources[options][fields]=title,product_type,variants.title,vendor,tag&section_id=predictive-search';
      fetch(url, { signal: controller.signal })
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var tmp = document.createElement('div'); tmp.innerHTML = html;
          var fresh = tmp.querySelector('[data-predictive-results]');
          results.innerHTML = fresh ? fresh.innerHTML : '';
          paintWishlist();
        })
        .catch(function (err) { if (err.name !== 'AbortError') results.innerHTML = ''; });
    }
    input.addEventListener('input', function () {
      var q = input.value.trim();
      clearTimeout(timer);
      if (q.length < 2) { results.innerHTML = ''; discovery.hidden = false; lastQuery = ''; return; }
      discovery.hidden = true;
      if (q === lastQuery) return;
      lastQuery = q;
      timer = setTimeout(function () { search(q); }, 180);
    });
    var suggestDone = false;
    dialog.addEventListener('jz:open', function () {
      input.focus();
      /* You may also like: the fallback collection is already in the page; add Shopify's related products once, on first open */
      var suggest = dialog.querySelector('[data-suggest]');
      if (suggest && !suggestDone) {
        suggestDone = true;
        upgradeSuggest(suggest, suggest.getAttribute('data-suggest-product') || store(RV_KEY, [])[0]);
      }
      setTimeout(updateStrips, 0);
      if (recentBlock) {
        var ids = store(RV_KEY, []).slice(0, 8);
        if (!ids.length) { recentBlock.hidden = true; return; }
        fetchProductsSection('search-recent', ids).then(function (r) {
          var grid = recentBlock.querySelector('[data-recent-grid]');
          if (!r || !grid || !r.children.length) { recentBlock.hidden = true; return; }
          grid.innerHTML = r.innerHTML; orderCards(grid, ids.map(String)); recentBlock.hidden = false;
          paintWishlist();
        });
      }
    });
  }

  /* ---------- You may also like (search overlay, bag) ----------
     Order of sources: Shopify related products for the seed product → the server-rendered collection cards already in the grid.
     Never a product twice; in the search overlay products that are shown under "Recently viewed" are left out when enough others remain. */
  function upgradeSuggest(block, productId) {
    var grid = block.querySelector('[data-suggest-grid]');
    var base = block.getAttribute('data-suggest-url');
    if (!grid) return;
    var limit = Number(block.getAttribute('data-limit') || 8);
    var exclude = block.getAttribute('data-exclude') || '';
    var recent = block.hasAttribute('data-suggest-search') ? store(RV_KEY, []).slice(0, 8).map(String) : [];
    function assemble(related) {
      var seen = {}; var all = [];
      related.concat($$('[data-product-card]', grid)).forEach(function (c) {
        var id = c.getAttribute('data-product-id');
        if (seen[id] || exclude.indexOf('|' + id + '|') !== -1) return;
        seen[id] = 1; all.push(c);
      });
      var fresh = all.filter(function (c) { return recent.indexOf(c.getAttribute('data-product-id')) === -1; });
      /* products not shown under Recently viewed first; the others only fill up the row when fewer than 12 remain */
      var pick = fresh.length >= Math.min(limit, 12) ? fresh.slice(0, limit) : fresh.concat(all.filter(function (c) { return fresh.indexOf(c) === -1; })).slice(0, limit);
      var frag = document.createDocumentFragment(); pick.forEach(function (c) { frag.appendChild(c); });
      grid.innerHTML = ''; grid.appendChild(frag);
      paintWishlist(); updateStrips();
    }
    if (!base || !productId) { assemble([]); return; }
    fetch(base + '?section_id=suggest-products&product_id=' + encodeURIComponent(productId) + '&limit=10&intent=related')
      .then(function (r) { return r.ok ? r.text() : ''; })
      .then(function (html) {
        var tmp = document.createElement('div'); tmp.innerHTML = html || '';
        assemble($$('[data-product-card]', tmp));
      }).catch(function () { assemble([]); });
  }
  function initSuggest() {
    $$('[data-suggest]').forEach(function (block) {
      if (block.hasAttribute('data-suggest-lazy')) return;
      upgradeSuggest(block, block.getAttribute('data-suggest-product'));
    });
  }

  /* ---------- Product image system: trim transparent product images to the product and centre them ----------
     The card marks a transparent image with data-cutout (a 160px copy of the image). Its alpha bounding box is measured once,
     cached in localStorage, and turned into percentages, so the product fills the padded canvas at the same visual size on every card. */
  var CUT_KEY = 'jz_cutout_v1';
  var cutCache = store(CUT_KEY, {});
  var cutPending = {};
  function cutoutBox(src) {
    var key = src.split('?')[0].split('/').pop();
    if (cutCache[key]) return Promise.resolve(cutCache[key]);
    if (cutPending[key]) return cutPending[key];
    cutPending[key] = new Promise(function (resolve) {
      var img = new Image();
      img.crossOrigin = 'anonymous';
      img.onload = function () {
        try {
          var w = img.naturalWidth, h = img.naturalHeight;
          var c = document.createElement('canvas'); c.width = w; c.height = h;
          var ctx = c.getContext('2d'); ctx.drawImage(img, 0, 0);
          var d = ctx.getImageData(0, 0, w, h).data;
          var x0 = w, y0 = h, x1 = -1, y1 = -1;
          for (var y = 0; y < h; y++) for (var x = 0; x < w; x++) {
            if (d[(y * w + x) * 4 + 3] > 24) { if (x < x0) x0 = x; if (x > x1) x1 = x; if (y < y0) y0 = y; if (y > y1) y1 = y; }
          }
          /* no transparent margin at all (a PNG photo with a background) or an empty image: leave it untouched */
          var box = (x1 < 0 || (x0 === 0 && y0 === 0 && x1 === w - 1 && y1 === h - 1)) ? { full: 1 } : { x: x0 / w, y: y0 / h, w: (x1 - x0 + 1) / w, h: (y1 - y0 + 1) / h, r: w / h };
          cutCache[key] = box; save(CUT_KEY, cutCache);
          resolve(box);
        } catch (e) { resolve({ full: 1 }); }
      };
      img.onerror = function () { resolve({ full: 1 }); };
      img.src = src;
    });
    return cutPending[key];
  }
  function fitCutouts() {
    $$('[data-cutout]:not(.is-fit):not(.is-plain)').forEach(function (wrap) {
      cutoutBox(wrap.getAttribute('data-cutout')).then(function (b) {
        var link = wrap.querySelector('a');
        if (b.full || !link) { wrap.classList.add('is-plain'); var plain = wrap.querySelector('.primary-image'); if (plain) { plain.style.opacity = 1; plain.style.animation = 'none'; } return; }
        var W = wrap.clientWidth, H = wrap.clientHeight;
        if (!W || !H) return; /* hidden (closed dialog, inactive tab): fitted when it becomes visible */
        var pad = parseFloat(getComputedStyle(link).paddingLeft) || 0;
        var cw = W - 2 * pad, ch = H - 2 * pad;
        /* rendered image width (px) so that the product itself fills the padded canvas, never upscaled past 3x of "contain" */
        var iw = Math.min(cw / b.w, (ch / b.h) * b.r, Math.min(cw, ch * b.r) * 3);
        var ih = iw / b.r;
        var left = pad + cw / 2 - (b.x + b.w / 2) * iw;
        var top = pad + ch / 2 - (b.y + b.h / 2) * ih;
        wrap.style.setProperty('--cut-w', (iw / W * 100).toFixed(3) + '%');
        wrap.style.setProperty('--cut-l', (left / W * 100).toFixed(3) + '%');
        wrap.style.setProperty('--cut-t', (top / H * 100).toFixed(3) + '%');
        wrap.classList.add('is-fit');
      });
    });
  }
  document.addEventListener('jz:open', function () { setTimeout(fitCutouts, 0); }, true);
  document.addEventListener('click', function (e) { if (e.target.closest('[data-tab]')) setTimeout(fitCutouts, 0); });

  /* ---------- Horizontal product rows (search "You may also like"): arrows page by the visible width ---------- */
  function updateStrips() {
    $$('[data-strip-block]').forEach(function (block) {
      var strip = block.querySelector('[data-strip]'); var arrows = block.querySelector('[data-strip-arrows]');
      if (!strip || !arrows) return;
      var overflow = strip.scrollWidth > strip.clientWidth + 4;
      arrows.hidden = !overflow || window.matchMedia('(max-width: 880px)').matches;
      var prev = arrows.querySelector('[data-strip-prev]'); var next = arrows.querySelector('[data-strip-next]');
      if (prev) prev.disabled = strip.scrollLeft <= 2;
      if (next) next.disabled = strip.scrollLeft + strip.clientWidth >= strip.scrollWidth - 2;
    });
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-strip-prev], [data-strip-next]');
    if (!b) return;
    var strip = b.closest('[data-strip-block]').querySelector('[data-strip]');
    var first = strip.firstElementChild; var gap = parseFloat(getComputedStyle(strip).columnGap) || 0;
    var page = first ? Math.round(strip.clientWidth / (first.getBoundingClientRect().width + gap)) * (first.getBoundingClientRect().width + gap) : strip.clientWidth;
    strip.scrollBy({ left: (b.hasAttribute('data-strip-next') ? 1 : -1) * page, behavior: JZ.settings.animations ? 'smooth' : 'auto' });
  });
  document.addEventListener('scroll', function (e) { if (e.target.matches && e.target.matches('[data-strip]')) { updateStrips(); fitCutouts(); } }, true);
  window.addEventListener('resize', updateStrips);

  /* ---------- Product page: a product is not shown under both "You may also like" and "Recently viewed" ---------- */
  function dedupeRecent() {
    var rec = {}; $$('[data-recommendations] [data-product-card]').forEach(function (c) { rec[c.getAttribute('data-product-id')] = 1; });
    $$('[data-recently-viewed]').forEach(function (section) {
      var grid = section.querySelector('[data-recent-grid]'); if (!grid || !grid.children.length) return;
      $$('[data-product-card]', grid).forEach(function (c) { if (rec[c.getAttribute('data-product-id')]) c.remove(); });
      if (!grid.children.length) section.hidden = true;
    });
  }
  document.addEventListener('jz:wishlist:change', dedupeRecent);

  /* ---------- Signup popup: once, after a delay or a scroll depth; a dismissal is remembered ---------- */
  var SU_KEY = 'jz_signup';
  function initSignup() {
    var dlg = $('[data-signup]');
    if (!dlg) return;
    var done = dlg.querySelector('[data-signup-success]');
    if (done && /customer_posted=true/.test(window.location.search)) { save(SU_KEY, { joined: 1, t: Date.now() }); openDialog(dlg); return; }
    if (document.documentElement.classList.contains('shopify-design-mode')) return;
    var state = store(SU_KEY, null);
    var days = Number(dlg.getAttribute('data-days') || 30);
    if (state && (state.joined || Date.now() - state.t < days * 864e5)) return;
    dlg.addEventListener('close', function () { var st = store(SU_KEY, null); if (!st || !st.joined) save(SU_KEY, { t: Date.now() }); });
    var shown = false, tries = 0;
    function show() {
      if (shown) return;
      if (document.querySelector('dialog.jz-dialog[open]')) { if (tries++ < 20) setTimeout(show, 4000); return; } /* never on top of the menu, search, bag or market dialog */
      shown = true; window.removeEventListener('scroll', onScroll); openDialog(dlg);
    }
    function onScroll() {
      var max = document.documentElement.scrollHeight - window.innerHeight;
      if (max > 400 && window.scrollY / max >= Number(dlg.getAttribute('data-scroll') || 50) / 100) show();
    }
    setTimeout(show, Number(dlg.getAttribute('data-delay') || 10) * 1000);
    window.addEventListener('scroll', onScroll, { passive: true });
  }
  document.addEventListener('shopify:section:select', function (e) { var d = e.target.querySelector && e.target.querySelector('[data-signup]'); if (d) openDialog(d); });
  document.addEventListener('shopify:section:deselect', function (e) { var d = e.target.querySelector && e.target.querySelector('[data-signup]'); if (d) closeDialog(d); });

  /* ---------- Product image zoom (full-screen viewer) ---------- */
  function initZoom() {
    var dialog = $('[data-dialog="zoom"]');
    if (!dialog) return;
    var img = dialog.querySelector('[data-zoom-img]'); var stage = dialog.querySelector('[data-zoom-stage]');
    var count = dialog.querySelector('[data-zoom-count]'); var nav = dialog.querySelector('[data-zoom-nav]');
    var figs = [], index = 0;
    function show(i) {
      figs = $$('[data-zoom-src]');
      if (!figs.length) return;
      index = (i + figs.length) % figs.length;
      stage.classList.remove('is-zoomed');
      img.src = figs[index].getAttribute('data-zoom-src');
      img.alt = figs[index].getAttribute('data-zoom-alt') || '';
      if (count) count.textContent = (index + 1) + ' / ' + figs.length;
      if (nav) nav.hidden = figs.length < 2;
    }
    document.addEventListener('click', function (e) {
      var fig = e.target.closest('[data-zoom-src]');
      if (fig && (e.target.closest('[data-zoom-open]') || e.target.tagName === 'IMG')) {
        show($$('[data-zoom-src]').indexOf(fig));
        openDialog(dialog, fig.querySelector('[data-zoom-open]'));
        return;
      }
      var step = e.target.closest('[data-zoom-step]');
      if (step) { show(index + Number(step.getAttribute('data-zoom-step'))); return; }
      if (e.target === img) {
        /* toggle 1:1 detail view, centred on the point that was clicked */
        var r = img.getBoundingClientRect(); var fx = (e.clientX - r.left) / r.width; var fy = (e.clientY - r.top) / r.height;
        var zoomed = stage.classList.toggle('is-zoomed');
        if (zoomed) { stage.scrollLeft = fx * stage.scrollWidth - stage.clientWidth / 2; stage.scrollTop = fy * stage.scrollHeight - stage.clientHeight / 2; }
      }
    });
    dialog.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') show(index + 1);
      if (e.key === 'ArrowLeft') show(index - 1);
    });
  }

  /* ---------- Client services: ?topic=return preselects the contact topic ---------- */
  function initContactTopic() {
    var select = $('[data-contact-topic]');
    if (!select) return;
    var want = (new URLSearchParams(window.location.search).get('topic') || '').toLowerCase();
    if (!want) return;
    Array.prototype.forEach.call(select.options, function (o) { if (o.value && o.value.toLowerCase().indexOf(want) === 0) select.value = o.value; });
  }

  /* ---------- Market welcome & selector ---------- */
  var MK_KEY = 'jz_market';
  function initMarket() {
    var welcome = $('[data-dialog="market-welcome"]');
    var stored = store(MK_KEY, null);
    var current = (JZ.market.country || '') + '/' + (JZ.market.language || '');
    if (welcome && !stored && !document.documentElement.classList.contains('shopify-design-mode')) {
      setTimeout(function () { if (!document.querySelector('dialog.jz-dialog[open]')) openDialog(welcome); }, 400);
      /* dismissing with the cross, Escape or the backdrop counts as "continue": never ask again on the next page */
      welcome.addEventListener('close', function () { if (!store(MK_KEY, null)) save(MK_KEY, current); });
    }
    document.addEventListener('click', function (e) {
      var cont = e.target.closest('[data-market-continue]');
      if (cont) { save(MK_KEY, current); closeDialog(welcome); return; }
      var pick = e.target.closest('[data-market-country], [data-market-locale]');
      if (!pick) return;
      e.preventDefault();
      var form = pick.closest('form');
      if (!form) return;
      var country = pick.getAttribute('data-market-country');
      var locale = pick.getAttribute('data-market-locale');
      if (country) form.querySelector('[name="country_code"]').value = country;
      if (locale) form.querySelector('[name="locale_code"]').value = locale;
      save(MK_KEY, (country || JZ.market.country) + '/' + (locale || JZ.market.language));
      form.submit();
    });
    document.addEventListener('change', function (e) {
      if (!e.target.matches('[data-localization-select]')) return;
      var form = e.target.closest('form');
      save(MK_KEY, 'select');
      form.submit();
    });
  }

  /* ---------- Tabs (featured collection) ---------- */
  document.addEventListener('click', function (e) {
    var tab = e.target.closest('[data-tab]');
    if (!tab) return;
    var group = tab.closest('[data-tabs]');
    $$('[data-tab]', group).forEach(function (t) { t.setAttribute('aria-selected', t === tab ? 'true' : 'false'); });
    $$('[data-tab-panel]', group).forEach(function (p) { p.hidden = p.getAttribute('data-tab-panel') !== tab.getAttribute('data-tab'); });
  });

  /* ---------- Reveal on scroll ---------- */
  function initReveal() {
    if (!JZ.settings.animations || !('IntersectionObserver' in window)) { $$('.reveal').forEach(function (el) { el.classList.add('in'); }); return; }
    var io = new IntersectionObserver(function (entries) { entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('in'); io.unobserve(en.target); } }); }, { rootMargin: '0px 0px -8% 0px' });
    $$('.reveal').forEach(function (el) { io.observe(el); });
  }

  /* ---------- Collection filters (mobile sheet mirrors desktop form) ---------- */
  function initFilters() {
    var sort = $('[data-sort-select]');
    if (sort) sort.addEventListener('change', function () {
      var url = new URL(window.location.href); url.searchParams.set('sort_by', sort.value); url.searchParams.delete('page'); window.location.href = url.toString();
    });
    var form = $('[data-filter-form]');
    if (form) form.addEventListener('change', function (e) { if (e.target.type === 'checkbox') form.requestSubmit ? form.requestSubmit() : form.submit(); });
  }

  /* ---------- Category discovery: every item keeps its image on filtered pages ---------- */
  function initDiscovery() {
    $$('[data-discovery]').forEach(function (nav) {
      var url = nav.getAttribute('data-source-url');
      if (!url) return;
      var cacheKey = 'jz_disc_' + url;
      function fill(map) {
        $$('[data-discovery-key]', nav).forEach(function (item) {
          var media = item.querySelector('.discovery__media');
          var html = map[item.getAttribute('data-discovery-key')];
          if (media && !media.querySelector('img') && html) media.innerHTML = html;
        });
      }
      var cached = null;
      try { cached = JSON.parse(sessionStorage.getItem(cacheKey) || 'null'); } catch (e) {}
      if (cached) fill(cached);
      var missing = $$('.discovery__media', nav).some(function (m) { return !m.querySelector('img'); });
      if (!missing) return;
      fetch(url).then(function (r) { return r.ok ? r.text() : ''; }).then(function (html) {
        if (!html) return;
        var tmp = document.createElement('div'); tmp.innerHTML = html;
        var map = {};
        $$('[data-discovery-key]', tmp).forEach(function (item) {
          var img = item.querySelector('.discovery__media img');
          if (img) map[item.getAttribute('data-discovery-key')] = img.outerHTML;
        });
        try { sessionStorage.setItem(cacheKey, JSON.stringify(map)); } catch (e) {}
        fill(map);
      }).catch(function () {});
    });
  }

  /* ---------- Init ---------- */
  function init() {
    $$('[data-product-form]').forEach(initProductForm);
    initSearch();
    initMarket();
    initReveal();
    initFilters();
    initMobileAdd();
    initDiscovery();
    initSuggest();
    initZoom();
    initContactTopic();
    initSignup();
    recordView();
    paintWishlist();
    renderWishlistPage();
    renderRecentlyViewed();
    fetch(JZ.routes.cart + '.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (c) { updateCartCount(c.item_count || 0); }).catch(function () {});
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', function () { $$('[data-product-form]').forEach(initProductForm); paintWishlist(); renderRecentlyViewed(); });
  window.JZ.api = { addToCart: addToCart, wishlist: wishlist, toast: toast, openDialog: openDialog, closeDialog: closeDialog };
})();
